
import React from 'react';
import { ZoomIn } from 'lucide-react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { imageVariants } from './animations';
import type { ImageType } from './types';

interface GalleryImageProps {
  image: ImageType;
  onClick: () => void;
}

export const GalleryImage = ({ image, onClick }: GalleryImageProps) => {
  return (
    <motion.div 
      variants={imageVariants}
      className="bg-white rounded-lg border-2 border-primary/30 shadow-lg transition-all duration-300 hover:scale-110"
      onClick={onClick}
    >
      <div className="relative aspect-square overflow-hidden">
        <img 
          src={image.src}
          alt={image.alt} 
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105 rounded-t-lg"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/30 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center rounded-t-lg">
          <div className="bg-primary/80 p-2 rounded-full">
            <ZoomIn className="text-white" size={24} />
          </div>
        </div>
      </div>
      <div className="p-4">
        <p className="text-paragraph text-sm">{image.alt}</p>
      </div>
    </motion.div>
  );
};
